import './assets/tailwind.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'leaflet/dist/leaflet.css'

if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
	window.addEventListener('unhandledrejection', (event) => {
		const reason = event?.reason

		console.error('Unhandled promise rejection captured:', {
			reason,
			message: reason?.message || String(reason),
			stack: reason?.stack || null,
		})

		// Prevent webpack-dev-server overlay from showing opaque
		// "Unknown promise rejection reason" popups.
		event.preventDefault()
	})
}

const app = createApp(App)
const pinia = createPinia()

app.use(router)
app.use(pinia)
app.mount('#app')

